import React, { useContext, useEffect } from 'react';
import Styled from './DialogosSocioemocionais.styled';
import OverviewExclusivo from '../components/OverviewExclusivo';
import MateriaisExclusivos from '../components/MateriasExclusivos';
import { ListMateriaisDialogosSocioemocionais } from './ListMateriaisDialogosSocioemocionais';
import CicloExclusivo from '../components/CicloExclusivo';
import ContactContainer from 'pages/home/components/contact/ContactContainer';
import { AcessoExclusivoContext } from 'pages/acessoExclusivo/context/AcessoExclusivoContext';
import Loading from 'components/Loading';
import { IsMobileBiggerWidth } from 'core/util/WindowSize';
import dialogosLogo from './../../../../images/solutions/logo/dialogosLogo.png';
import UsuarioDTO from 'models/UsuarioDTO';
import { useAppSelector } from 'hooks/LocalReduxThunk';
import SessionFerramentaVideo from 'pages/acessoExclusivo/components/SessionFerramentaVideo';

const DialogosSocioemocionaisPrivate = () => {
    const { loading, idsMyCategorias } = useContext(AcessoExclusivoContext.Context);
    const isMobile = IsMobileBiggerWidth();
    const usuarioLogado: UsuarioDTO = useAppSelector(state => state.authenticationReducer.usuarioLogado);

    const materiaisFiltrados = ListMateriaisDialogosSocioemocionais.filter(item => {
        const semRestricao = !item.categoriasPermitidas && !item.permitirEmail;

        if (semRestricao) {
            return true;
        }

        const possuiCategoria = item.categoriasPermitidas?.some(id => idsMyCategorias.includes(id)) ?? false;

        const possuiEmailIAS = item.permitirEmail && usuarioLogado.email.includes('@ias');

        return possuiCategoria || possuiEmailIAS;
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Styled.Container isMobile={isMobile}>
            {loading ? (
                <>
                    <Loading />
                </>
            ) : (
                <>
                    <OverviewExclusivo
                        isBlue
                        mencao={
                            [1, 2, 7, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? 'Ministério da Cultura apresenta o projeto Plano Anual Instituto Ayrton Senna.'
                                : [35].some(id => idsMyCategorias.includes(id))
                                ? 'Ministério da Cultura apresenta o projeto Apoio Cultural e Educacional para Escolas das Redes Públicas Estadual e Municipal do Instituto Ayrton Senna.'
                                : ''
                        }
                        img="anexo_storage_files_11566250207537833097.jpg_2024-11-26-1732646957514.jpg"
                        logo={dialogosLogo}
                        title="Diálogos Socioemocionais"
                        description={`
                            O Diálogos Socioemocionais é uma proposta do Instituto Ayrton Senna feita para apoiar o trabalho de educadores e gestores na promoção do desenvolvimento socioemocional dos estudantes. 
                            A ideia é que esse trabalho aconteça de forma planejada, intencional e conectada com o dia a dia da escola. 
                            <br/><br/>
                            A proposta se baseia em estudos e evidências, e convida o professor a ser um mediador ativo da aprendizagem, com atividades que valorizam o diálogo, 
                            a escuta e o protagonismo dos estudantes. As práticas seguem o que chamamos de abordagem SAFE — são sequenciais, ativas, focadas e explícitas — e utilizam metodologias ativas, 
                            avaliação formativa e espaços de conversa com sentido. 
                            <br/><br/>
                            Para os gestores e as Secretarias de Educação, o programa também oferece uma forma de acompanhar o processo ao longo do tempo, por meio de uma sistemática de monitoramento 
                            com uso de dados e avaliações formativas. Isso ajuda a pensar em ações contínuas e integradas, que façam sentido na escola.
                            <br/><br/>
                            Com tudo isso, o Diálogos Socioemocionais quer contribuir para uma educação mais integral — que olhe para o estudante como um todo, considerando tanto os aspectos acadêmicos quanto os emocionais, 
                            sempre em sintonia com as orientações da BNCC. 
                          `}
                        arquivo={'anexo_storage_files_2839206562349981815.pdf_2024-11-27-1732735828100.pdf'}
                        regua={
                            [1, 2, 7, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? 'Reguas_Logo/2026_Regua_Plano_Anual_Defeso_Eleitoral_pequena.jpg'
                                : [35].some(id => idsMyCategorias.includes(id))
                                ? 'Reguas_Logo/2026_Regua_Roanet_Disseminacao_Hor_apoio_comprimida.jpg'
                                : ''
                        }
                        nome_arquivo="Dialogos_Socioemocionais_Visao_Geral"
                    />
                    <CicloExclusivo
                        title="Trilha Formativa Diálogos Socioemocionais"
                        description={`
                    Nesta trilha formativa, você vai conhecer os principais conteúdos do Diálogos Socioemocionais de forma simples e organizada. A proposta é apoiar profissionais da educação, 
                    técnicos das Secretarias, gestores regionais, coordenadores pedagógicos e professores para que se apropriem das ideias, práticas e ferramentas necessárias à implementação da 
                    proposta nas escolas. 
                    <br/><br/>
                    Cada etapa da trilha foi pensada para fortalecer o seu papel na construção de uma educação que valoriza tanto o desenvolvimento acadêmico quanto o socioemocional dos estudantes. 
                    <br/><br/>
                    Vamos juntos? Comece agora a sua trilha formativa! 
                    `}
                        img="anexo_storage_files_16448016042645220309.jpg_2024-11-26-1732646995405.jpg"
                        singleColumn
                        itens={
                            [9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? [
                                      {
                                          title: (
                                              <>
                                                  Diálogos Integrados - Professores
                                                  <br />
                                                  (Formação Inicial)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-integrados?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos Integrados - Professores
                                                  <br />
                                                  (Formação Continuada 1)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-integrados-uso-pedagogico-devolutivas?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos Integrados - Professores
                                                  <br />
                                                  (Formação Continuada 2)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-integrados-sistematica?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos Projeto de Vida - Professores
                                                  <br />
                                                  (Formação Inicial)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-projeto-de-vida?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos Projeto de Vida - Professores
                                                  <br />
                                                  (Formação Continuada 1)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-pv-uso-pedagogico-devolutivas?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos Projeto de Vida - Professores
                                                  <br />
                                                  (Formação Continuada 2)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-projeto-de-vida-sistematica?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos para Coordenadores
                                                  <br />
                                                  (Formação Inicial)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-socioemocionais-cp?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos para Coordenadores
                                                  <br />
                                                  (Formação Continuada 1)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/devolutivas_coordenacao?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos para Coordenadores
                                                  <br />
                                                  (Formação Continuada 2)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-coordenacao-sistematica?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                  ]
                                : [2, 13, 26].some(id => idsMyCategorias.includes(id))
                                ? [
                                      {
                                          title: (
                                              <>
                                                  Diálogos Projeto de Vida - Professores
                                                  <br />
                                                  (Formação Inicial)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-projeto-de-vida?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos Projeto de Vida - Professores
                                                  <br />
                                                  (Formação Continuada 1)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-pv-uso-pedagogico-devolutivas?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos Projeto de Vida - Professores
                                                  <br />
                                                  (Formação Continuada 2)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-projeto-de-vida-sistematica?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos para Coordenadores
                                                  <br />
                                                  (Formação Inicial)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-socioemocionais-cp?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos para Coordenadores
                                                  <br />
                                                  (Formação Continuada 1)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/devolutivas_coordenacao?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos para Coordenadores
                                                  <br />
                                                  (Formação Continuada 2)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-coordenacao-sistematica?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                  ]
                                : [7, 15, 18, 19, 20].some(id => idsMyCategorias.includes(id))
                                ? [
                                      {
                                          title: (
                                              <>
                                                  Diálogos Integrados - Professores
                                                  <br />
                                                  (Formação Inicial)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-integrados?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos Integrados - Professores
                                                  <br />
                                                  (Formação Continuada 1)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-integrados-uso-pedagogico-devolutivas?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos Integrados - Professores
                                                  <br />
                                                  (Formação Continuada 2)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-integrados-sistematica?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos para Coordenadores
                                                  <br />
                                                  (Formação Inicial)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-socioemocionais-cp?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos para Coordenadores
                                                  <br />
                                                  (Formação Continuada 1)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/devolutivas_coordenacao?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos para Coordenadores
                                                  <br />
                                                  (Formação Continuada 2)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-coordenacao-sistematica?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                  ]
                                : [1].some(id => idsMyCategorias.includes(id))
                                ? [
                                      {
                                          title: (
                                              <>
                                                  Diálogos Integrados - Professores
                                                  <br />
                                                  (Formação Inicial)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-integrados?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos Integrados - Professores
                                                  <br />
                                                  (Formação Continuada 1)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-integrados-uso-pedagogico-devolutivas?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos para Coordenadores
                                                  <br />
                                                  (Formação Inicial)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-socioemocionais-cp?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos para Coordenadores
                                                  <br />
                                                  (Formação Continuada 1)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/devolutivas_coordenacao?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                  ]
                                : [35].some(id => idsMyCategorias.includes(id))
                                ? [
                                      {
                                          title: (
                                              <>
                                                  Diálogos Integrados - Professores
                                                  <br />
                                                  (Formação Inicial)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-integrados?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos Projeto de Vida - Professores
                                                  <br />
                                                  (Formação Inicial)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-projeto-de-vida?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                      {
                                          title: (
                                              <>
                                                  Diálogos para Coordenadores
                                                  <br />
                                                  (Formação Inicial)
                                              </>
                                          ),
                                          url: '/cursos/dialogos_socioemocionais/dialogos-socioemocionais-cp?redirect=exclusivo/dialogos-socioemocionais',
                                          isBlock: false,
                                          titleIsBlock: `Curso não está disponível.`,
                                      },
                                  ]
                                : []
                        }
                    />

                    <MateriaisExclusivos
                        title="Materiais especiais para download"
                        description={` 
                            Tenha acesso aos materiais exclusivos do Diálogos Socioemocionais, conheça melhor a proposta e comece a desenhar os próximos passos rumo à implementação na sua rede. 
                            Cada conteúdo foi pensado para apoiar o seu trabalho e tornar a prática pedagógica ainda mais significativa.
                            `}
                        img={'anexo_storage_files_14472106021717107526.svg_2024-11-26-1732639689100.svg'}
                        items={materiaisFiltrados}
                    />
                    <SessionFerramentaVideo solucaoId={6} />
                    <ContactContainer />
                </>
            )}
        </Styled.Container>
    );
};

export default DialogosSocioemocionaisPrivate;
